import React, { useMemo } from "react";

import { faAdd, faSave } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { MenuProps } from "antd/es/menu";
import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  create: {
    id: "filters.savedFilters.unsavedChangesDropdown.create",
    defaultMessage: "Save as new",
    description: "Save as new menu item in Unsaved SavedFilter changes dropdown",
  },
  update: {
    id: "filters.savedFilters.unsavedChangesDropdown.update",
    defaultMessage: "Save changes",
    description: "Save changes menu item in Unsaved SavedFilter changes dropdown",
  },
});

export const useSavedFiltersDropdownMenu = (
  onUpdate?: () => void,
  onCreate?: () => void
): MenuProps => {
  const intl = useIntl();

  return useMemo(() => {
    return {
      items: [
        {
          icon: <FontAwesomeIcon icon={faSave} />,
          key: "update",
          label: intl.formatMessage(messages.update),
          onClick: onUpdate,
        },
        {
          icon: <FontAwesomeIcon icon={faAdd} />,
          key: "create",
          label: intl.formatMessage(messages.create),
          onClick: onCreate,
        },
      ],
    };
  }, [intl, onUpdate, onCreate]);
};
